import PropTypes from 'prop-types';
import React from "react";
import Modal from "./Modal.jsx";

import "./HelpModal.css";

const SECTIONS = {
    "General": [
        ["\u2190", "Previous chart"],
        ["\u2192", "Next chart"],
        ["\u2193", "Zoom out"],
        ["\u2191", "Zoom in"],
        ["D", "Duplicate current chart"],
        ["E", "Export data"],
        ["S", "Share"],
        ["N", "New chart"],
        ["P", "Screenshot"],
        ["C", "Configure chart"],
        ["DELETE", "Delete current chart"],
        ["shift \u2190", "Move current chart to left"],
        ["shift \u2192", "Move current chart to right"]
    ]
};

class Row  extends React.Component {
    static propTypes = {
        keys: PropTypes.string.isRequired,
        desc: PropTypes.string
    };

    render(){
        var keys = [];
        this.props.keys
            .split(" ")
            .forEach((key, i)=> {
                if (i > 0) {
                    keys.push(<span key={i + "+"}>+</span>);
                }
                keys.push(<span key={i} className="key">{key}</span>);
            });

        return (
            <tr>
                <td>{keys}</td>
                <td>{this.props.desc}</td>
            </tr>
        );
    }
}

function renderKeymap(sections) {
    var rows = [];
    for (let name of Object.keys(sections)) {
        let section = sections[name];
        rows.push(
            <tr key={name}>
                <th colSpan="2">{name}</th>
            </tr>
        );

        let i = 0;
        for (let [keys, desc] of section) {
            rows.push(<Row key={i++} keys={keys} desc={desc}/>);
        }
    }
    return rows;
}

const HELP_CONTENTS = renderKeymap(SECTIONS);

export default class HelpModal extends Modal {
    static defaultProps = {
        title: "Help"
    };

    static displayName = 'HelpModal';

    renderTrigger() {
        return <span className="help-toggle">?</span>;
    }

    renderContent() {
        return (
            <div className="help">
                <table>
                    <tbody>
                    {HELP_CONTENTS}
                    </tbody>
                </table>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/kpi/components/HelpModal.jsx